import { FunctionComponent } from 'react';
import { useFullOrder } from '@/clients/order/useOrder.ts';
import { useParams } from 'react-router';
import { GetOrderResponse } from '@schuettflix/interfaces';

export interface OrderLoaderComponentProps {
    order?: GetOrderResponse;
}

type WithOrderProps = {
    orderId: string;
};

export function OrderLoader<ComponentProps extends OrderLoaderComponentProps>(
    Component: FunctionComponent<ComponentProps>
) {
    function WithOrder({ orderId }: WithOrderProps) {
        const { data: order, isError, error } = useFullOrder(orderId);

        if (isError) {
            throw new Error(error.message);
        }

        return (props: ComponentProps) => <Component order={order} {...props} />;
    }

    return function OrderLoaderRenderer(props: ComponentProps) {
        const { orderId } = useParams<{ orderId: string }>();

        if (!orderId) {
            return <Component {...props} />;
        }

        return WithOrder({ orderId })(props);
    };
}
